import React, { createContext, useState, useMemo, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const addToCart = (product, selectedOptions, finalPrice) => {
    setCartItems(prevItems => {
      const cartItemId = selectedOptions && Object.keys(selectedOptions).length > 0
        ? `${product.id}-${Object.values(selectedOptions).join('-')}`
        : product.id.toString();

      const existingItem = prevItems.find(item => item.cartItemId === cartItemId);

      if (existingItem) {
        return prevItems.map(item =>
          item.cartItemId === cartItemId
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      
      const newItem = { 
        ...product, 
        quantity: 1, 
        selectedOptions,
        cartItemId,
        price: finalPrice 
      };
      return [...prevItems, newItem];
    });
    setIsCartOpen(true);
  };

  const updateQuantity = (cartItemId, amount) => {
     setCartItems(prevItems =>
      prevItems
        .map(item => {
          if (item.cartItemId === cartItemId) {
            const newQuantity = item.quantity + amount;
            return newQuantity > 0 ? { ...item, quantity: newQuantity } : null;
          }
          return item;
        })
        .filter(Boolean)
    );
  };

  const removeItem = (cartItemId) => {
    setCartItems(prevItems => prevItems.filter(item => item.cartItemId !== cartItemId));
  };
  
  const cartItemCount = useMemo(() => {
    return cartItems.reduce((acc, item) => acc + item.quantity, 0);
  }, [cartItems]);
  
  const cartTotal = useMemo(() => {
    return cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
  }, [cartItems]);

  const value = {
    cartItems,
    addToCart,
    updateQuantity,
    removeItem,
    cartItemCount,
    cartTotal,
    isCartOpen,
    setIsCartOpen,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};